import React from 'react';
import { Footer, TitleBar } from '../../../components';
import TitleUpdater from '../../../components/common/TitleUpdater';

import ApplicationDependencyMapping from '../../../components/assets/ApplicationDependencyMapping';
import ApplicationWorkarounds from '../../../components/assets/ApplicationWorkarounds';
import HostingEntitiesMapping from '../../../components/assets/HostingEntitiesMapping';
import HostingEntitiesMitigation from '../../../components/assets/HostingEntitiesMitigation';
import { CyberModuleCard } from '../components';

const CyberCards = [
  {
    icon: <ApplicationDependencyMapping />,
    title: 'Application Dependency Mapping',
    description:
      'Determine how enterprise applications support the organization.',
    link: '/cyber/enterprise-level',
    isActive: true,
  },
  {
    icon: <ApplicationWorkarounds />,
    title: 'Application Workarounds',
    description:
      'Capture workarounds to reduce the impact of application disruptions.',
    link: '/cyber/enterprise-level/application-workarounds',
    isActive: true,
  },
  {
    icon: <HostingEntitiesMapping />,
    title: 'Hosting Entities Mapping',
    description: 'Capture where applications are hosted.',
    link: '#',
    isActive: false,
  },
  {
    icon: <HostingEntitiesMitigation />,
    title: 'Hosting Entities Mitigation',
    description:
      'Capture mitigation strategies to reduce the impact of hosting entity disruptions.',
    link: '#',
    isActive: false,
  },
];

export const EnterpriseApplicationsList = () => {
  return (
    <div className="min-h-screen">
      <TitleUpdater title="Enterprise Level Applications" />
      <TitleBar
        title="Enterprise Level Applications"
        subtitle="Overview"
        brief="This section is all about capturing the importance and workarounds for applications and hosting entities at the corporate level. Starting with Application Dependency Mapping will allow you to build a comprehensive view of what matters most."
      />
      <div className="w-full">
        {CyberCards.map((card) => (
          <CyberModuleCard
            key={card.title}
            icon={card.icon}
            title={card.title}
            description={card.description}
            link={card.link}
            isActive={card.isActive}
          />
        ))}
      </div>
      <Footer backPath="/cyber" />
    </div>
  );
};
